<template>
  <router-link class="treeview" tag="li" v-if="router && router.name" :to="router">
    <a href="#">
      <i :class="icon"></i> <span style="width:228px; background:#183764;" >{{ name }}</span>
      <!-- <span class="pull-right-container" v-show="badge">
        <small class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
      </span> -->
    </a>
  </router-link>
  <li  :class="getType" v-else>
    {{ isHeader ? name : '' }}
    <a href="#" v-if="window.width < 770">
      <i :class="icon"></i> <span class="side-sub">{{ name }}</span>
    </a>
    <a href="#" v-if="!isHeader && window.width > 770">
      <i :class="icon"></i> <span class="side-sub">{{ name }}</span>
      <!-- <span class="pull-right-container">
        <small v-if="badge && badge.data" class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
        <i v-else class="fa fa-angle-left pull-right"></i>
      </span> -->
    </a>
    <ul id="treeMenu" class="treeview-menu" v-if="items.length > 0" style="width: 228px">
      <router-link tag="li" v-for="(item,index) in items" :data="item" :key="index" :to="item.router" v-if="item.router && item.router.name">
        <a>
          <i :class="item.icon"></i> {{ item.name }}
        </a>
      </router-link>
      <li v-else>
        <a>
          <i :class="item.icon"></i> {{ item.name }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'va-slide-item',
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    router: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created () {
  },
  mounted () {
    $('.treeview').click(function () {
      var thisMenu = $(this).children('.treeview-menu')
      $('.treeview-menu').each(function () {
        if (thisMenu.filter(function (element) { return element === $(this) }).length) {
          return
        }
        $(this).css('display', '')
      })
    })

    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  computed: {
    getType () {
      if (this.isHeader) {
        return 'header treeview'
      }
      return this.type === 'item' ? '' : 'treeview'
    }
  }
}
</script>
<style>

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a {
  height: 44px;
}

.sidebar-mini.sidebar-collapse .sidebar-menu>li>a:hover {
    background: #183764 !important;
}

/*
.skin-green .sidebar-menu>li>a:hover{
  background: #183764 !important;
}
*/
.sidebar-menu>li>a{
  padding: 12px 5px;
}

.side-sub{
width:228px !important; 
background:#183764 !important;
  border-radius:0px !important;
}

.treeview-menu>li{
  position: relative;
  right: 5px;
  bottom: 5px;
  background:#2C3B41;
  width: 228px !important;
} 

/*
.treeview-menu>li:hover{
background: #183764 !important;
} 
*/

.treeview-menu{
  background: none !important;
}

#treeMenu{
  background:none!important;
}

.headerTree-a{
  background-color: #183764 !important;
}

</style>



// WEBPACK FOOTER //
// VASlideItem.vue?1e08b891